import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import { Pressable } from "@/components/ui/pressable";
import React from 'react'
import i18n from "i18n-js";
import {  IconM, IconMC } from '@/components/media/IconsV2';

export default function Toast({ top, right, icon, iconmc, title, toast, setToast}) {
    if (toast) return (
        <Pressable onPress={() => setToast(false)} className={`shadow-hard-3 ${right || 'right-[200px]'} ${top || 'top-[5px]'} absolute rounded-[8px] p-2 bg-primary-900 `}>
            <HStack space='md' className="px-2">
                {icon && <IconM size={30} className='text-secondary-50 pt-1' name={icon} />}
                {iconmc && <IconMC size={30} className='text-secondary-50 pt-1' name={iconmc} />}
                <Text className="text-xl font-bold text-secondary-50">{i18n.t(title)}</Text>
            </HStack>
        </Pressable>
    );
}

